/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */

import dateFormat from '@/tools/dateFormat';
import HistoryProject from '../child/history-project';
import ProjectSet from '../child/project-set';
import CurrentMonthProject from '../child/current-month-project';
import { agentManager } from '@/api/ajax';
import { taxCollectionPatternMap } from '@/config/staticData';
import { moneyFixed } from '@/tools/money';
import createExtend from '@/components/createExtend';
import UpdateUserPhoneForm from '../child/update-phone';
import { REAL_NAME_STATUS, PHONE_UPDATE_ENABLE } from './constand.js';
import Vue from 'vue';
import { Message } from 'element-ui';
// 自然人交易结构，不包含个体
let personTaxCollectionPatternMap = { ...taxCollectionPatternMap };
delete personTaxCollectionPatternMap[5];

export default {
  index: {
    width: '80px',
    label: '序号',
    type: 'index'
  },
  fullName: {
    label: '项目参与人',
    prop: 'fullName'
  },
  operator: {
    label: '经营者',
    prop: 'fullName'
  },
  enterpriseName: {
    label: '个体',
    prop: 'enterpriseName'
  },
  phone: {
    label: '手机号',
    prop: 'phone',
    width: '180px',
    render: (h, c, r) => {
      Vue.util.defineReactive(c.parent, 'activeIndex', 0);

      const { updateFlag: phoneUpdateFlag, fullName, phone } = r; // 可修改手机号  0：不可以修改 1：可以修改
      const canAlterPhone = phoneUpdateFlag === PHONE_UPDATE_ENABLE;

      const showDialog = () => {
        if (!canAlterPhone) return;
        const theForm = createExtend(UpdateUserPhoneForm, {
          fullNameLabel: +c.parent.activeIndex === 0 ? '项目参与人' : '经营者',
          fullName,
          phone
        });
        theForm.$on('finished', async phone => {
          const {
            data: { message, status }
          } = await agentManager.updateOrMergeUserPhone({
            newPhone: phone,
            userId: r.userId
          });
          if (+status === 1) {
            c.parent.$message.success(message);
            theForm.remove();
            c.parent.$refs.search.sure();
          } else {
            c.parent.$message.error(message);
          }
        });
        theForm.$on('remove', theForm.remove);
      };
      return (
        <div style={{ alignItems: 'baseline', margin: '0 auto' }}>
          <span>{r.phone}</span>

          <el-button
            style={{ marginLeft: '8px', opacity: canAlterPhone ? 1 : 0 }}
            type="text"
            disabled={!canAlterPhone}
            onClick={showDialog}
          >
            修改
          </el-button>
        </div>
      );
    }
  },
  realNameStatus: {
    label: '实名认证',
    prop: 'authStatus',
    render: (h, c, r) => {
      return (
        <span>{{ ...REAL_NAME_STATUS, 2: '认证失败' }[r.authStatus]}</span>
      );
    }
  },
  taxCollectionPattern: {
    label: '交易结构',
    prop: 'taxCollectionPattern',
    formatter(r, c, v) {
      let taxText = (v || '').split(',').reduce((pre, cur) => {
        pre += cur ? personTaxCollectionPatternMap[cur] + ' ' : '';
        return pre;
      }, '');
      return taxText || '-';
    }
  },
  createDt: {
    label: '首次导入时间',
    prop: 'createDt',
    formatter(r, c, v) {
      return dateFormat(v, 'YYYY-MM-DD HH:mm:ss');
    }
  },
  taskSumSurplus: {
    label: '剩余预采购任务量',
    prop: 'taskSumSurplus',
    render: (h, ctx, row) => {
      return (
        <span>
          {Number.isFinite(row.taskSumSurplus) ? row.taskSumSurplus : '-'}
        </span>
      );
    }
  },
  passingTaskSumPlatform: {
    label: '系统接收中任务量',
    width: 200,
    prop: 'passingTaskSumPlatform',
    render: (h, ctx, row) => {
      return (
        <span>
          {Number.isFinite(row.passingTaskSumPlatform)
            ? row.passingTaskSumPlatform
            : '-'}
        </span>
      );
    }
  },
  passTaskSumPlatform: {
    label: '系统已接收任务量',
    width: 180,
    prop: 'passTaskSumPlatform',
    render: (h, ctx, row) => {
      return (
        <span>
          {Number.isFinite(row.passTaskSumPlatform)
            ? row.passTaskSumPlatform
            : '-'}
        </span>
      );
    }
  },
  passingTaskSum: {
    label: '待审核任务量',
    prop: 'passingTaskSum',
    render: (h, ctx, row) => {
      return (
        <span>
          {Number.isFinite(row.passingTaskSum) ? row.passingTaskSum : '-'}
        </span>
      );
    }
  },
  taskSumNoFinishPrice: {
    label: '预采购金额（含税）',
    width: 200,
    prop: 'taskSumNoFinishPrice',
    render: (h, ctx, row) => {
      return (
        <span>
          {!['', null, undefined].includes(row.taskSumNoFinishPrice)
            ? row.taskSumNoFinishPrice + '元'
            : '-'}
        </span>
      );
    }
  },
  userAmount: {
    label: '预计结算服务总价（含税）',
    width: 200,
    prop: 'userAmount',
    render: (h, ctx, row) => {
      return (
        <span v-loading={row.amountLoading}>
          {moneyFixed(row.userAmount) || '-'}
        </span>
      );
    }
  },
  noFinishTaskSum: {
    label: '未完成任务量',
    prop: 'noFinishTaskSum',
    render: (h, ctx, row) => {
      return (
        <span>
          {Number.isFinite(row.noFinishTaskSum) ? row.noFinishTaskSum : '-'}
        </span>
      );
    }
  },
  historyProject: {
    width: '180px',
    label: '参与项目数量',
    prop: 'historyProject',
    render(h, ctx, row) {
      let vm = ctx.parent;
      let showDialog = () => {
        vm.$xrkDialog({
          title: '项目详情',
          width: '90%',
          showConfirm: false,
          cancelType: 'primary',
          cancelText: '确认',
          $slots: {
            default: h(HistoryProject, {
              props: {
                row,
                userId: row.userId,
                source: 1
              }
            })
          }
        });
      };
      return (
        <el-button type="text" onClick={showDialog}>
          {row.projectCount}
        </el-button>
      );
    }
  },
  projectNum: {
    width: '180px',
    label: '本月参与项目',
    prop: 'projectNum',
    render(h, ctx, row) {
      let vm = ctx.parent;
      let showDialog = () => {
        vm.$xrkDialog.call(vm, {
          title: '本月参与项目',
          width: '90%',
          showConfirm: false,
          cancelType: 'primary',
          cancelText: '确认',
          $slots: {
            default: h(CurrentMonthProject, {
              props: {
                userId: row.userId,
                fullName: row.fullName,
                phone: row.phone,
                status: row.status // 组件使用，用于判断为2时是否可添加
              }
            })
          }
        });
      };
      return (
        <el-button type="text" onClick={showDialog}>
          {row.projectNumCurrentMonth}
        </el-button>
      );
    }
  },
  prePurchaseProsces: {
    prop: 'finishRate',
    label: '预采购任务量完成进度',
    width: 200,
    render: (h, ctx, row) => {
      const process = row.finishRate;
      return Number.isFinite(process) ? (
        <el-progress stroke-width={10} percentage={process} color={'#FF8B3C'}>
          <span style={{ fontSize: '12px' }}>{process}%</span>
        </el-progress>
      ) : (
        <span>{'-'}</span>
      );
    }
  },
  status: {
    width: '180px',
    label: '启用状态',
    prop: 'status',
    render(h, ctx, row) {
      let switchChange = async () => {
        await agentManager.agentForbiddenOrActive({
          userId: row.userId,
          status: row.status === 1 ? 2 : 1
        });
        row.status = row.status === 1 ? 2 : 1;
      };
      // userStatus 3 账号注销
      return row.userStatus == 3 ? (
        // <span>已注销</span>
        <el-switch
          disabled
          value={2}
          active-value={1}
          inactive-value={2}
          active-color="#13ce66"
          inactive-color="#ff4949"
        />
      ) : (
        <el-switch
          value={row.status}
          active-value={1}
          inactive-value={2}
          active-color="#13ce66"
          inactive-color="#ff4949"
          onchange={switchChange}
        />
      );
    }
  },
  occupationAuthStatus: {
    label: '职业认证',
    prop: 'occupationAuthStatus',
    render: (h, ctx, row) => {
      // 之前一直是用的occupationAuthStatus字段进行判断，但是22-06-24上线任务进度的时候，测试发现已认证账号显示的未认证，排查后发现，后端接口的字段已经改变
      // 因为考虑到一直没有OccupationAuthStatus字段，所以点击功能也都用不了的，所以就直接显示字段值
      const { authOrgName } = row;
      return (
        <span
          style={{ color: authOrgName === '未认证' ? '#c0c4cc' : '#409EFF' }}
        >
          {authOrgName}
        </span>
      );
    }
  },
  projectSet: {
    width: '180px',
    label: '启用状态',
    prop: 'projectSet',
    render(h, ctx, row) {
      let vm = ctx.parent;
      let showDialog = () => {
        vm.$xrkDialog({
          title: '项目详情',
          width: '90%',
          showConfirm: false,
          cancelType: 'primary',
          cancelText: '确认',
          $slots: {
            default: h(ProjectSet, {
              props: {
                userId: row.userId,
                source: 2
              }
            })
          }
        });
      };
      return (
        <el-button type="text" onClick={showDialog}>
          设置
        </el-button>
      );
    }
  },
  userTag: { label: '人员标签', prop: 'userTag' },
  submitNum: {
    label: '可结算任务量',
    prop: 'submitNum',
    render: (h, ctx, row) => {
      return (
        <span>{Number.isFinite(row.submitNum) ? row.submitNum : '-'}</span>
      );
    }
  }
};

export const createDownloadName = params => {
  const checkboxs = [
    {
      getDisabledStatus: query => query.estimateSettlementTime,
      type: 1,
      name: '按人汇总导出'
    },
    {
      type: 2,
      getDisabledStatus: () => false,
      name: '按人+工业+单价降序导出'
    }
  ];
  return {
    name: '名单下载',
    icon: '',
    type: 'warning',
    async fn(app, table) {
      const h = app.$root.$createElement;
      let query = { userType: params.userType };
      try {
        query = table.$refs.search.searchArr.reduce((pre, cur) => {
          !['', void 0, null].includes(cur.val) && (pre[cur.key] = cur.val);
          return pre;
        }, query);
      } catch (error) {
        console.warn(error);
      }
      console.log(query);
      const checkValue = new Set();
      const downloadBtn = h(
        'el-button',
        {
          style: { margin: '32px auto 14px', display: 'block' },
          props: { type: 'primary' },
          on: {
            click: async () => {
              if (checkValue.size == 0) {
                Message.error('请选择导出方式');
                return;
              }
              downloadBtn.componentInstance.loading = true;
              try {
                await agentManager.exportAgentList({
                  type: [...checkValue].join(','),
                  ...query
                });
                Message.success('已添加到下载中心');
                dialog.remove();
              } catch (error) {
                downloadBtn.componentInstance.loading = false;
              }
            }
          }
        },
        ['下载']
      );
      const dialog = app.$xrkDialog({
        title: '导出方式',
        width: '450px',
        showConfirm: false,
        showCancel: false,
        $slots: {
          default: h('div', {}, [
            h(
              'div',
              {},
              checkboxs.map(({ type, name, getDisabledStatus }) =>
                h(
                  'el-checkbox',
                  {
                    props: {
                      disabled: getDisabledStatus && getDisabledStatus(query)
                    },
                    on: {
                      change: value => {
                        if (value) {
                          checkValue.add(type);
                        } else {
                          checkValue.delete(type);
                        }
                      }
                    }
                  },
                  [name]
                )
              )
            ),
            downloadBtn
          ])
        }
      });
    }
  };
};
